import Plus from "@/assets/icons/plus.png"
import Minus from "@/assets/icons/minus.png"
import { diSanaQs } from "@/app/utils/constants"
import fullLogo from "@/assets/imgs/di-sana/form-cover/full-logo.webp"
import DefaultLayout from "@/layouts/Default"
import InfoContainer from "../components/InfoContainer"
import Input from "@/components/input/Input"
import { useForm } from "react-hook-form"
import { useEffect, useState } from "react"
import { useGlobalContext } from "@/global/GlobalContext"
import DiSanaAPI from "@/app/api/di-sana/di-sana"
import { getError, handleError } from "@/app/utils/helpers"
import { faqSchema } from "@/app/utils/validation"
import clsx from "clsx"
import { LoadButton } from "@/components/Button"
import ProcessModal from "@/components/ProcessModal"
const diSanaApi = new DiSanaAPI()

const DiSanaFAQ = () => {
  const { notifyError } = useGlobalContext()
  const { register, handleSubmit, reset } = useForm()
  const [modalContent, setModalContent] = useState(null)
  const [onSaving, setOnSaving] = useState(false)
  const defaultErr = {
    first_name: "",
    last_name: "",
    email: "",
    subject: "",
    message: "",
  }
  const [errors, setErrors] = useState(defaultErr)

  const showDetail = (id) => {
    const iconBtn = document.getElementById(`iconBtn${id}`)
    const detail = document.getElementById(`detail${id}`)
    const details = document.querySelectorAll(".detail-contents")
    const iconBtns = document.querySelectorAll(".icon-btn")

    for (const d of details) {
      if (!detail.isEqualNode(d)) {
        if (d.classList.contains("mb-8")) {
          d.classList.remove("mb-8")
          d.classList.add("h-0")
        }
      }
    }

    for (const c of iconBtns) {
      if (!iconBtn.isEqualNode(c)) {
        if (c.classList.contains("shown")) {
          c.src = Plus
        }
      }
    }

    if (!detail.classList.contains("mb-8")) {
      detail.classList.add("mb-8")
      detail.classList.remove("h-0")
      iconBtn.src = Minus
      iconBtn.classList.add("shown")
    } else {
      detail.classList.remove("mb-8")
      detail.classList.add("h-0")
      iconBtn.src = Plus
      iconBtn.classList.remove("shown")
    }
  }

  const onSubmit = async (formData) => {
    setOnSaving(true)
    const err = await createFaq(formData)
    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        setErrors({ ...newErrs })
      }
    }
    setOnSaving(false)
  }

  // API request
  const createFaq = async (formData) => {
    try {
      const insertedData = faqSchema.safeParse({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
      })

      if (!insertedData.success) return { error: insertedData.error.issues }
      const inserted = {
        first_name: insertedData.data.first_name,
        last_name: insertedData.data.last_name,
        email: insertedData.data.email,
        subject: insertedData.data.subject,
        message: insertedData.data.message,
      }

      const { data } = await diSanaApi.createFaq(inserted)
      if (data.code == 200) {
        setModalContent({ msg: "Thank you for your message! We'll review your message and get back to you shortly.", isOpen: true })
        reset()
        setErrors(defaultErr)
      }
    } catch (err) {
      return getError(err)
    }
  }

  return (
    <>
      <ProcessModal pModalContent={modalContent} />
      <DefaultLayout>
        <InfoContainer title="FAQ/Frequently Asked Questions">
          {diSanaQs.map((q, i) => (
            <div key={i} className="font-agcasmlt font-light border-b-[1.5px] border-[#6d625a] mb-12">
              <div className="flex justify-between items-center">
                <span className="uppercase text-[#6d625a] text-xl sm:text-2xl md:text-3xl lg:text-4xl">{q.title}</span>
                <button onClick={() => showDetail(q.id)} type="button">
                  <img id={`iconBtn${q.id}`} width="100" src={Plus} className="w-4 icon-btn" />
                </button>
              </div>
              <div id={`detail${q.id}`} className="detail-contents mt-6 h-0 overflow-hidden transition-all">
                <span className="text-justify text-[#6d625a] text-lg sm:text-xl">{q.detail}</span>
              </div>
            </div>
          ))}
        </InfoContainer>
        <section className="px-10 lg:px-20 py-12">
          <div className="lg:flex lg:gap-x-8">
            <div className="max-lg:mb-14 w-3/4 sm:w-2/3 lg:w-1/2 max-lg:mx-auto my-auto font-agcasmlt font-light text-[#6d625a]">
              <div className="max-lg:text-center mb-5 sm:mb-10">
                <h2 className="max-lg:text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-3 md:mb-6">Any Questions?</h2>
                <span className="text-[24px] sm:text-[26px]">If you have questions any general information, please complete this form to request the information you need. It will be an honor to help you.</span>
              </div>
              <div className="max-lg:mx-auto border-b-[1.5px] border-[#6d625a] w-4/5"></div>
            </div>
            <div className="w-full sm:w-4/5 lg:w-1/2 mx-auto">
              <div className="px-5 sm:px-10 lg:px-12 py-10 sm:py-12 relative bg-[url('/src/assets/imgs/di-sana/form-cover/paper-cover.webp')] overflow-hidden" style={{ boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)" }}>
                <div className="">
                  <h1 className="font-sloopScriptPro text-[#6e6059] text-3xl md:text-5xl lg:text-7xl">Send a message</h1>
                  <div className="mt-2 sm:mt-3 md:mt-4 xl:mt-4 w-full">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="w-[90%] mb-5">
                        <label className="font-agcasmlt font-light text-[#6d625a] text-lg sm:text-xl lg:text-2xl inline-block mb-1">Name:</label>
                        <div className="flex gap-x-5">
                          <div className="w-1/2">
                            <Input required type="text" placeholder="First Name" name="firstName" id="firstName" isInput1 noLabel custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" custCls={errors.first_name ? "border-red-600" : ""} errMsg={errors.first_name} ref={{ ...register("first_name") }} />
                          </div>
                          <div className="w-1/2">
                            <Input required type="text" placeholder="Last Name" name="lastName" id="lastName" isInput1 noLabel custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" custCls={errors.last_name ? "border-red-600" : ""} errMsg={errors.last_name} ref={{ ...register("last_name") }} />
                          </div>
                        </div>
                      </div>
                      <div className="w-3/5 mb-5">
                        <Input required type="email" placeholder="Email" name="email" label="Email:" id="email" isInput1 custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" custCls={errors.email ? "border-red-600" : ""} errMsg={errors.email} ref={{ ...register("email") }} />
                      </div>
                      <div className="w-3/5 mb-5">
                        <Input required type="text" placeholder="Subject" name="subject" label="Subject:" id="subject" isInput1 custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" custCls={errors.subject ? "border-red-600" : ""} errMsg={errors.subject} ref={{ ...register("subject") }} />
                      </div>
                      <div className="w-[90%] mb-5">
                        <label className="font-agcasmlt font-light text-[#6d625a] text-lg sm:text-xl lg:text-2xl inline-block mb-1">Message:</label>
                        <div>
                          <textarea rows="5" placeholder="Message" className={clsx("border-[1.5px] border-[#6d625a] font-agcasmlt font-light text-base placeholder-[#9f978e] pt-2 px-2 focus:outline-none w-full bg-transparent", { "border-red-600": errors.message })} {...register("message")}></textarea>
                        </div>
                        {errors.message && (
                          <span className="text-[10px] sm:text-[12px] text-red-600">{errors.message}</span>
                        )}
                      </div>
                      <LoadButton type="submit" isLoading={onSaving} text="Send" />
                    </form>
                  </div>
                </div>
                <div className="absolute top-3 right-5">
                  <img width="100" src={fullLogo} className="w-20 md:w-28 lg:w-32" />
                </div>
              </div>
            </div>
          </div>
        </section >
      </DefaultLayout>
    </>
  )
}

export default DiSanaFAQ